import React from 'react';
import ReactDOM from 'react-dom';
import App from './app';
import { SvgIcon } from './components/SvgIcon';

// 自定义svg渲染元素：利用shadowdom隔离样式
customElements.define("svg-icon", SvgIcon);

ReactDOM.render(<App />, document.getElementById('root'));
